<template>
  <el-container id="container">
    <el-header style="padding: 0px;justify-content: space-between;display: flex;" background-color="#545c64">
      <el-menu background-color="#1e1f23" :default-active="ui.activeIndex" class="el-menu-demo" mode="horizontal"
        @select="handleSelect" text-color="#fff" active-text-color="#ffd04b" :router="true">
        <el-menu-item index="lxg">端游伤害计算器</el-menu-item>
        <el-menu-item index="lxgW">手游伤害计算器</el-menu-item>
        <!--        <el-submenu index="2">
            <template slot="title">我的工作台</template>
<el-menu-item index="2-1">选项1</el-menu-item>
<el-menu-item index="2-2">选项2</el-menu-item>
<el-menu-item index="2-3">选项3</el-menu-item>
<el-submenu index="2-4">
  <template slot="title">选项4</template>
  <el-menu-item index="2-4-1">选项1</el-menu-item>
  <el-menu-item index="2-4-2">选项2</el-menu-item>
  <el-menu-item index="2-4-3">选项3</el-menu-item>
</el-submenu>c
</el-submenu>
<el-menu-item index="3" disabled>消息中心</el-menu-item>
<el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item> -->
      </el-menu>
      <div>
        <el-button type="text" @click="refreshCookies" style="font-size: 20px;margin-right: 10px">刷新缓存</el-button>
        <el-button type="text" @click="activeDialogOpen" style="font-size: 20px;margin-right: 10px">近期活动</el-button>
        <el-button type="text" @click="open" style="font-size: 20px;margin-right: 50px">更新日志</el-button>
      </div>
    </el-header>
    <el-container id="center-container">
      <aside class="aside">
        <div style="height: 100%;">
          <img src="../assets/左侧.jpg" class="bg-img" v-if="ui.showImg" />
        </div>
      </aside>
      <el-container id="main-container" direction="vertical">
        <el-main>
          <router-view></router-view>
        </el-main>
        <!--        <el-footer style="height: 30px;text-align: center;padding: 5px;line-height: 20px;background-color: #dbdbdb;">
              <a class="text-color" href="http://www.beian.gov.cn/portal/registerlxgWstemInfo?recordcode=11000002000001" target="_blank">京公网安备11000002000001号</a>
          </el-footer> -->
      </el-container>
      <aside class="aside">
        <div style="height: 100%;background-color: black;">
          <img src="../assets/右侧.jpg" class="bg-img" v-if="ui.showImg" />
        </div>
      </aside>
    </el-container>
    <el-footer style="padding: 0px;height: 20px;position: absolute;bottom: 0;">
      <div style="background-color: #ffffff;display: flex;height: 20px;width: 100vw;text-align: center;">
        <el-link type="info" style="text-align: center;margin-left: auto;margin-right: auto;line-height: 20px;"
          href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2023039019号-1</el-link>
      </div>
    </el-footer>
    <!--    <div class="floating-component">
        <el-link type="info" style="text-align: center;margin-left: auto;margin-right: auto;" href="http://www.beian.gov.cn/portal/registerlxgWstemInfo?recordcode=11000002000001">备案信息预备</el-link>
      </div> -->

    <el-dialog title="凌雪阁近期活动" :visible.lxgWnc="activeDialog" width="800px" custom-class="activeDialog"
      @open="activeDialogOpen()" top="20px" center>
      <div style="height: 820px;overflow: auto;display: flex">
        <div>
          <img src="../assets/冷龙峰团建.png" style="height: 800px" />
        </div>
        <div style="padding-left: 30px;">
          <div style="font-size: 18px;font-weight: bold;text-align: center;">凌雪天团群</div>
          <img src="../assets/凌雪天团群.png" style="height: 180px" />

          <div>
            <div style="font-size: 18px;font-weight: bold;text-align: center;">凌雪PVE1群</div>
            <img src="../assets/凌雪PVE1群.png" style="height: 180px" />
          </div>
          <div>
            <div style="font-size: 18px;font-weight: bold;text-align: center;">凌雪PVE2群</div>
            <img src="../assets/凌雪PVE2群.png" style="height: 180px" />
          </div>
          <div>
            <div>
              <div style="font-size: 18px;font-weight: bold;text-align: center;">双梦凌雪群</div>
              <img src="../assets/双梦凌雪群.png" style="height: 180px" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>

export default {
  data() {
    return {
      activeDialog: false,
      ui: {
        showImg: true,
        activeIndex: 'lxg'
      }
    };
  },
  mounted() {
    // 新赛季清除缓存
    var newCache = localStorage.getItem("2025-05-27 refreshCache");
    if(!newCache){
      localStorage.removeItem("lxg:income1");
      localStorage.removeItem("lxgW:income1");
      localStorage.setItem("2025-05-27 refreshCache", true);
    }

    this.ui.activeIndex = this.$route.params.target
    


    var isRead = localStorage.getItem("isRead_20240822")
    if (!isRead) {
      // this.activeDialogOpen()
      this.open();
      localStorage.setItem("isRead_20240822", true)
    }

  },
  methods: {
    open() {
      this.$alert(
        "<div style='height:400px;overflow-y:auto'>"
        + "<h3>2024年10月31日 <h4>1、上线无界计算器功能。</h4><h4>2、更新至丝路风雨版本。</h4><h4>3、增加装备过滤功能。</h4>|</br>|</br>|", '更新日志', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',

        // callback: action => {
        //   this.$message({
        //     type: 'info',
        //     message: `action: ${ action }`
        //   });
        // }
      });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$route.params.target = key;
      // console.log("开始存储");
      // console.log(keyPath);
      // localStorage.setItem('activeIndex', keyPath);
      // console.log(key, keyPath);
    },
    activeDialogOpen() {
      this.activeDialog = true;
    },
    refreshCookies(){
      localStorage.clear();
      location.reload();
    }
  }
}
</script>
<style lang="less" scoped>
.el-header {
  background-color: rgb(30, 31, 35);
  text-align: center;
  justify-content: center;
  font-size: 40px;
  height: 30px;
  color: red;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.el-footer {
  background-color: #b4adb5;
  color: #333;
  line-height: 60px;
}

.aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
  height: 100%;
  // width: 20vw;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
}

.el-main {
  height: 100%;
  background-image: url("../assets/配装器背景图\ new.jpg");
  color: #333;
  text-align: center;
  line-height: 40px;
  border-radius: 10px;
  background-size: cover;
  padding-bottom: 100px;


  // background-image: url('../assets/2.jpg')
}

bolxg>.el-container {
  margin-bottom: 0px;
  margin: 0px;
  overflow: auto;
}

#container {
  overflow: auto;
  height: 100%;
  display: block;
}


#center-container {
  height: calc(100% - 60px);
}

#main-container {
  overflow: auto;

}

/deep/ #main-container {
  flex: 1 0 auto;
  max-width: 100vw;
  overflow-x: auto;
  background-color: black;

}


.bg-img {
  min-width: 0px;
  overflow-x: hidden;
  overflow-y: hidden;
  vertical-align: bottom;
  vertical-align: middle;
  vertical-align: top;

  height: 100%;
}

::v-deep .activeDialog .el-dialog__bolxg {
  padding-top: 0px;
  padding-left: 20px;

  .el-dialog-title {
    line-height: 30px;
    text-align: left;
    color: brown;
    margin-left: 20px;
    font-weight: bold;
    font-size: 18px;
    font-family: 宋体;
  }
}
</style>
